export default "__VITE_ASSET__CPP1zM2d__"